<template>
  <div class="demandBox">
    <div class="demandDetails w1200Auto">
      <div class="flex-item-center breadcrumb">
        <span style="font-size: 14px; padding-left: 5px">当前位置：</span>
        <el-breadcrumb separator="/">
          <el-breadcrumb-item :to="{ path: '/supplyHome' }">首页</el-breadcrumb-item>
          <el-breadcrumb-item :to="{ path: '/supplyHome' }">供需对接</el-breadcrumb-item>
          <el-breadcrumb-item
            style="cursor: pointer"
            :to="{ name: 'serviceList' }"
            >服务列表</el-breadcrumb-item
          >
          <el-breadcrumb-item style="color: #009999"
            >服务详情</el-breadcrumb-item
          >
        </el-breadcrumb>
      </div>
      <div class="demandDetails_mesg">
        <div class="mesg_bob_left">
          <div class="bacgk mesg_bob_left_top">
            <div class="flex-item-center mesg_top_box">
              <div class="mesg_top_box_imgs">
                <el-carousel height="280px" class="carouselImg carouselImgbox">
                  <el-carousel-item v-for="(item, index) in serviceInfo.imgPaths" :key="index">
                    <img :src="item.url" alt="" class="carouselImg"/>
                    <div class="mesg_top_numsbox">
                      {{index+1}}/{{serviceInfo.imgPaths.length}}
                    </div>
                  </el-carousel-item>
                </el-carousel>

                <div class="flex mesg_top_nums">
                  <p class="flex-item-center">成交量：{{ serviceInfo.orderNum }}</p>
                  <p class="flex-item-center">好评率：{{ evaluationNumber }}%</p>
                </div>
              </div>
              <div class="mesg_top_box_cont">
                <div class="flex-item-center-between">
                  <h2>{{ serviceInfo.title }}</h2>
                  <p class="mesg_top_text" @click="handleCollect">
                    <i :class="collect"></i> 收藏
                  </p>
                </div>
                <div class="flex mesg_top_box_js">
                  <p>
                    ¥
                    <span>{{ serviceInfo.money }}</span>
                  </p>
                  <span class="yijia">{{serviceInfo.isBargain=='0'?'议价':'不可议'}}</span>
                </div>
                <div class="mesg_servers">
                  <p>
                    行业领域：
                    <span class="mesg_content"
                      >{{ serviceInfo.oneLabel }}-{{
                        serviceInfo.twoLabel
                      }}</span
                    >
                  </p>
                  <p>
                    项目地址：
                    <span class="mesg_content">
                      {{ serviceInfo.addProvince }} {{ serviceInfo.addCity }}
                      {{ serviceInfo.addArea }}
                    </span>
                  </p>
                  <p>
                    服务类型：
                    <span class="mesg_content">{{ serviceInfo.type }}</span>
                  </p>
                </div>


                <div class="flex-item-center mesg_btn">
                  <el-button type="primary" @click="getInquiry" style="margin-right: 20px"
                    >立即询价</el-button
                  >
                  <!-- <el-button type="primary" plain>联系商家</el-button> -->
                  <el-popover
                    placement="top-start"
                    width="339"
                    trigger="click">
                    <div class="popverMesg">
                      <p>企业名称：{{enterpriseInfo.name }}</p>
                      <p>联系人：{{ enterpriseInfo.contact }}</p>
                      <p>联系电话：{{ enterpriseInfo.contactTel }}</p>
                      <p>联系邮箱：{{ enterpriseInfo.contactMail }}</p>
                    </div>
                    <el-button slot="reference" type="primary" plain>联系商家</el-button>
                  </el-popover>
                </div>
              </div>
            </div>
          </div>
          <div class="bacgk">
            <el-tabs v-model="activeName" @tab-click="handleClick">
              <el-tab-pane
                label="服务详情"
                name="first"
                v-html="serviceInfo.content"
              ></el-tab-pane>
              <el-tab-pane label="评价详情" name="second">
                <div class="evaluationDetails" v-if="conmmentList.length > 0">
<!--                  <div class="flex right_sortbox">
                    <p>综合评分：9.9评分</p>
                    <p>100%售后服务</p>

                  </div>-->
                  <div v-for="(items, index) in conmmentList" :key="index" style="border-bottom: 1px solid #E0E0E0;">
                    <div class="comList flex">
                      <div class="flex">
                        <div class="comList_img">
                          <img
                            :src="
                              items.iconUrl
                                ? items.iconUrl
                                : require('../../../../assets/users.png')
                            "
                            alt=""
                          />
                        </div>
                        <div class="comList_con">
                          <p class="con_title">
                            <span>
                              {{ items.creator }}
                            </span>
                          </p>
                          <div class="flex" style="margin-bottom: 15px">
                            <p class="flex" style="margin-right: 15px">
                              <span style="margin-right: 5px">
                                描述
                              </span>
                              <el-rate
                                  v-model="items.descriptionPoint"
                                  disabled
                                  :colors="colors"
                              ></el-rate>
                            </p>
                            <p class="flex" style="margin-right: 15px">
                              <span style="margin-right: 5px">
                                服务
                              </span>
                              <el-rate
                                  v-model="items.servicePoint"
                                  disabled
                                  :colors="colors"
                              ></el-rate>
                            </p>
                            <p class="flex" style="margin-right: 15px">
                              <span style="margin-right: 5px">
                                专业
                              </span>
                              <el-rate
                                  v-model="items.transportPoint"
                                  disabled
                                  :colors="colors"
                              ></el-rate>
                            </p>
                          </div>
                          <p class="con_mess">
                            {{ items.evaluationContent }}
                          </p>
                          <span class="con_time"> {{ items.createTime }}</span>
                          <div class="additional_review" v-if="items.addedReplys.length">
                            <div  v-for="(itemZh, indexZh) in items.addedReplys" :key="indexZh" style="margin-bottom: 10px">
                              <p>{{itemZh.evaluationType == 'REPLY' ? '商家' : ''}}{{itemZh.evaluationTypeCn}}：</p>
                              <p class="con_mess">
                                {{ itemZh.evaluationContent }}
                              </p>
                              <span class="con_time"> {{ itemZh.createTime }}</span>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
               <el-empty description="暂无评价" v-else></el-empty>
              </el-tab-pane>
            </el-tabs>
          </div>
        </div>
        <div class="mesg_bob_right">
          <serverDetailsRight ref="enterpriseInfoShow" :haoping="evaluationNumber"></serverDetailsRight>
        </div>
      </div>
      <!-- 立即询价 -->
      <inquire ref="inquiryRef"></inquire>
    </div>
  </div>
</template>

  <script>
import serverDetailsRight from "./serverDetailsRight";
import inquire from "./inquire";
import {
  askInquiry, findSellerSettledInfo, getServiceEvaluationList,
  isCollection,
  removeCollection,
  saveServiceCollection, saveVolumeCount,
  serviceDetail, getEvaluationNumber, saveVisitorLog
} from "../../../../utils/interface";
export default {
  components: { serverDetailsRight, inquire },
  data() {
    return {
      activeName: "first",
      sortBox: [
        {
          name: "全部",
          num: "2",
        },
      ],
      sortboxIndex: 0,
      conmmentList: [],
      colors: ["#FF9900", "#FF9900", "#FF9900"],
      collect: "el-icon-star-off",
      uuid: "",
      serviceInfo: {
        title: "",
        addProvince: "",
        addCity: "",
        addArea: "",
        money: "",
        type: "",
        classifyOne: "",
        classifyTwo: "",
        collectUuid: "",
      },
      enterpriseInfo:{},
      evaluationNumber:0,
    };
  },
  created() {
    this.uuid = this.$route.query.uuid;
    this.showDetail();
    if (this.$store.state.isLogin) {
      this.isCollectInfo();
    }
  },
  methods: {
    handleCollect() {
      console.log(
        "-----this.$store.state.isLogin--------" + this.$store.state.isLogin
      );
      if (this.$store.state.isLogin) {
        //登陆人 如果没有企业，用useruuid判断
        if (this.serviceInfo.createUser == this.$store.state.isUsermessage.uuid) {
          this.$message.error('无法收藏自己的服务');
          return false;
        }
        console.log("-----this.collect--------" + this.collect);
        if (this.collect == "el-icon-star-on") {
          // 收藏商品
          let params = {
            uuid: this.collectUuid,
          };
          removeCollection(params).then((res) => {
            if (res.success) {
              this.collect = "el-icon-star-off";
              this.$message.success("取消成功!");
              this.collectUuid = "";
              this.isCollectInfo();
            }
          });
        } else {
          // 收藏服务
          let params = {
            serviceabilityUuid: this.uuid,
            collectName: this.serviceInfo.title,
            type: 3,
          };
          saveServiceCollection(params).then((res) => {
            if (res.success) {
              this.collect = "el-icon-star-on";
              this.$message.success("收藏成功!");
              this.collectUuid = res.data.uuid;
              this.isCollectInfo();
            }
          });
        }
      } else {
        this.$message({
          type: "success",
          message: "您需要先登录哦！",
        });
        this.$router.push("/login");
      }
    },
    showDetail() {
      serviceDetail({ id: this.uuid }).then((res) => {
        this.serviceInfo = res.data;
        this.saveVolumeCount();
        this.saveVisitorLog();
        this.getEvaluationNumber(res.data.enterpriseUuid);
        findSellerSettledInfo({enterPriseId:res.data.enterpriseUuid}).then((item)=>{
          this.enterpriseInfo = item.data;
          this.$refs.enterpriseInfoShow.init(item.data,this.uuid)
        })
      });
      this.conmmentList = [];
      getServiceEvaluationList({serviceUuid:this.uuid}).then((res) => {
         if(res){
          this.conmmentList = res
          console.log(33, res)
         }
      });
    },
    getEvaluationNumber(enterpriseUuid) {
      getEvaluationNumber({
        serviceUuid: this.uuid,
        userUuid: enterpriseUuid
      }).then((res) => {
        if (res.success) {
          this.evaluationNumber =  Math.floor(res.data.evaluationNumber*100)/100;
        }
      });
    },
    handleClick(type) {
      // this.activeName = type;
      console.log(1111, type)
    },
    getInquiry() {
      if (this.$store.state.isLogin) {
        if (this.serviceInfo.enterpriseUuid == this.$store.state.isUsermessage.enterpriseUuid) {
          this.$message.error('不能询价自己的服务');
          return false;
        }
        askInquiry({serviceId:this.serviceInfo.id}).then((res)=>{
          if(res.success){
            let list={
              id:this.serviceInfo.id,
              title:this.serviceInfo.title,
              classifyOne:this.serviceInfo.classifyOne,
              classifyTwo:this.serviceInfo.classifyTwo,
              type:this.serviceInfo.type,
              money:this.serviceInfo.money,
              serviceCreatuser:this.serviceInfo.createUser
            }
            this.$refs.inquiryRef.init(list)
          }else {
            this.$message.error(res.message);
          }
        })

      } else {
        this.$message({
          type: "success",
          message: "您需要先登录哦！",
        });
        this.$router.push('/login')
      }
    },
    isCollectInfo() {
      let params = {
        serviceabilityUuid: this.uuid,
      };
      isCollection(params).then((res) => {
        if (res && res.data != null) {
          this.collect = "el-icon-star-on";
          this.collectUuid = res.data.uuid;
        } else {
          this.collect = "el-icon-star-off";
        }
      });
    },
    saveVolumeCount(){
      let param={
        userUuid:this.serviceInfo.createUser,
        volumeType:'SERVICE',
      }
      saveVolumeCount(param).then((res) => {
        if(res.success){
        }
      });
    },
    saveVisitorLog() {
      let param = {
        title: this.serviceInfo.title,
        logo: this.serviceInfo.mainPhotoUrl,
        visitorType: 'SERVICE',
        price: this.money,
        link: window.location.href
      };
      saveVisitorLog(param);
    },
  },
};
</script>

  <style lang="less" scoped>
@import "../../style/index.less";
.demandBox {
  background: #f5f8fc;
}
/deep/.el-carousel__indicators {
  display: none;
}
.popverMesg {
  line-height: 30px;
}
.demandDetails {
  padding: 20px;
  .breadcrumb {
    color: #999;
  }
  .bacgk {
    background: #fff;
    padding: 30px;
  }
  .demandDetails_mesg {
    margin-top: 20px;
    display: flex;
    justify-content: space-between;
    .mesg_bob_left {
      width: 885px;
      flex-shrink: 0;
      box-sizing: border-box;
      .mesg_bob_left_top {
        margin-bottom: 20px;
        height: 345px;
        box-sizing: border-box;
        .mesg_top_text {
          text-align: right;
          font-size: 14px;
          color: #333;
          cursor: pointer;
          &:hover {
            color: #009999;
          }
        }
        .mesg_top_box {
          .mesg_top_box_imgs {
            position: relative;
            .carouselImg {
              width: 440px;
              height: 280px;
              margin-right: 25px;
              flex-shrink: 0;
              border-radius: 8px;
            }
            .carouselImgbox {
              position: relative;
              .mesg_top_numsbox {
                position: absolute;
                bottom: 10px;
                right: 15px;
                color: #fff;
                background: rgba(0, 0, 0, 0.307);
                border-radius: 5px;
                padding: 5px 10px;
                font-size: 14px;
              }

            }
            .mesg_top_nums {
              z-index: 99;
              margin-top: 7px;
              position: absolute;
              top: 5px;
              left: 10px;
              background: rgba(0, 0, 0, 0.307);
              border-radius: 5px;
              padding: 5px 10px;
              p {
                font-size: 12px;
                color: #fff;
                min-width: 70px;
              }
            }
          }
          .mesg_top_box_cont {
            font-size: 14px;
            width: 100%;
            color: #777;
            h2 {
              font-size: 18px;
              margin-bottom: 23px;
              color: #000;
              width: 80%;
            }
            .mesg_top_box_js {
              color: #de3131;
              font-size: 14px;
              align-items: baseline;
              margin-bottom: 32px;
              span {
                font-size: 24px;
                color: #de3131;
                font-weight: 600;
              }
              .yijia {
                font-size: 14px;
                color: #169999;
                margin-left: 17px;
                font-weight: 400;
              }
            }
            .mesg_servers {
              // display: grid;
              // grid-template-columns: 50% 49%;
              // grid-column-gap: 8px;
              p {
                margin-bottom: 18px;
                font-size: 14px;
                color: #999999;
              }
              .mesg_content {
                font-size: 14px;
                font-family: PingFang SC-Regular, PingFang SC;
                color: #000000;
              }
            }
            span {
              color: #333;
            }
            .mesg_btn {
              margin-top: 30px;
            }

          }
        }
      }
    }
    .mesg_bob_right {
      width: 300px;
      box-sizing: border-box;
    }
  }
}
.right_sortbox {
  font-size: 14px;
  color: #333333;
  padding: 11px 23px;
  background: #f8f8f8;
  border-radius: 8px 8px 8px 8px;
  margin: 12px 32px;
  p {
    cursor: pointer;
    padding: 0 10px;
    margin-right: 20px;
  }
}
.comList {
  margin-left: 32px;
  border-radius: 10px;
  width: 100%;
  padding: 15px 0 29px;
  box-sizing: border-box;
  -moz-box-sizing: border-box; /* Firefox */
  -webkit-box-sizing: border-box; /* Safari */
  margin-top: 15px;
  justify-content: space-between;

  .comList_img {
    width: 55px;
    height: 55px;
    background: #efefef;
    border-radius: 50%;
    margin-right: 17px;

    img {
      width: 56px;
      height: 56px;
      border-radius: 50%;
    }
  }

  .comList_con {
    color: #777;
    margin-right: 10px;

    .con_title {
      display: flex;
      align-items: center;
      margin-bottom: 14px;
      font-size: 14px;
      font-weight: 600;
      color: #333333;
      span {
        margin-right: 16px;
      }
    }

    .con_mess {
      font-size: 14px;
      color: #333333;
      width: 93%;
    }
    .con_time {
      font-size: 12px;
      color: #999999;
      margin-top: 12px;
      display: inline-block;
    }
  }
  .additional_review {
    margin-top: 15px;
    border-top: 1px solid #efefef;
    padding: 15px;
    .con_mess {
      margin-top: 10px;
    }
  }
  .comList_star {
    flex-shrink: 0;

    .comList_star_A {
      align-content: center;
      margin-bottom: 3px;

      span {
        color: #b8b8b8;
        font-size: 13px;
        margin-right: 5px;
        line-height: 22px;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/supplyHome/components/details/serviceDetails.vue